import { showSessionExpiredModal, showSessionExpiringPopup } from './SessionExpiringPopup';
Oskari.clazz.category('Oskari.mapframework.bundle.statehandler.StateHandlerBundleInstance', 'state-methods', {
  /**
   * @method setSessionExpiring
   * @param {Number} minutes session length in minutes
   */
  setSessionExpiring: function setSessionExpiring(minutes) {
    if (!minutes) return;
    var me = this;
    var sandbox = this.getSandbox();
    sandbox.setSessionExpiring(minutes - 1, function () {
      var popupController = showSessionExpiringPopup(minutes, function () {
        var _document$querySelect;
        (_document$querySelect = document.querySelector("form[action='/logout']")) === null || _document$querySelect === void 0 || _document$querySelect.submit();
        popupController.close();
      }, function () {
        // continue session
        sandbox.extendSession(function () {
          showSessionExpiredModal();
        });
        me.setSessionExpiring(minutes);
        popupController.close();
      }, function () {
        // just close without reloading (use when switching to modal)
        popupController.close();
      });
    });
  },
  /**
   * @method resetSessionTimer
   * @param {Number} minutes session length in minutes
   */
  resetSessionTimer: function resetSessionTimer(minutes) {
    if (!minutes) return;

    // Clear old timer and set new one
    this.getSandbox().clearSessionTimer();
    this.setSessionExpiring(minutes);
  }
});